import { render, staticRenderFns } from "./PowerOff.vue?vue&type=template&id=dac39318"
import script from "./PowerOff.vue?vue&type=script&lang=js"
export * from "./PowerOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports